export const TOKEN_KEY = 'admin_token';
